require('./regexp-constructor-modal.component.scss');
import {
  escapeHtml
} from '../../../util/escape';

const REFS = [{
    name: gettext('A single character of: a, b or c'),
    ex: '[abc]',
    descrText: gettext('Matches either an a, b or c character'),
    descrEx: '[abc]+',
    results: [{
      t: 'a',
      s: true
    }, {
      t: ' ',
    }, {
      t: 'bb',
      s: true
    }, {
      t: ' ',
    }, {
      t: 'ccc',
      s: true
    }, ],
  },
  {

    name: gettext('A character except: a, b or c'),
    ex: '[^abc]',
    descrText: gettext('Matches any character except for an a, b or c'),
    descrEx: '[^abc]+',
    results: [{
      t: 'Anything ',
      s: true
    }, {
      t: 'b',
    }, {
      t: 'ut ',
      s: true
    }, {
      t: 'abc',
    }, {
      t: '.',
      s: true
    }, ],
  },
  {
    name: gettext('A character in the range: a-z'),
    ex: '[a-z]',
    descrText: gettext('Matches any characters between a and z, including a and z.'),
    descrEx: '[a-z]+',
    results: [{
      t: 'O',
    }, {
      t: 'nly',
      s: true,
    }, {
      t: ' ',
    }, {
      t: 'a',
      s: true
    }, {
      t: '-',
    }, {
      t: 'z',
      s: true
    }, ],
  },
  {
    name: gettext('A character not in the range: a-z'),
    ex: '[^a-z]',
    descrText: gettext('Matches any characters except those in the range a-z.'),
    descrEx: '[^a-z]+',
    results: [{
      t: 'A',
      s: true,
    }, {
      t: 'nything',
    }, {
      t: ' ',
      s: true,
    }, {
      t: 'but',
    }, {
      t: ' ',
      s: true,
    }, {
      t: 'a',
    }, {
      t: '-',
      s: true,
    }, {
      t: 'z',
    }, {
      t: '.',
      s: true
    }, ],
  },
  {
    name: gettext('A character in the range: a-z or A-Z'),
    ex: '[a-zA-Z]',
    descrText: gettext('Matches any characters between a-z or A-Z. You can combine as much as you please.'),
    descrEx: '[a-zA-Z]+',
    results: [{
      t: 'abc',
      s: true
    }, {
      t: '123',
    }, {
      t: 'DEF',
      s: true,
    }, ]
  },
  {
    name: gettext('Any single character'),
    ex: '.',
    descrText: gettext('Matches any character other than newline (or including line terminators with the /s flag)'),
    descrEx: '.+',
    results: [{
      t: 'a b c ',
      s: true,
    }],
  },
  {
    name: gettext('Alternate - match either a or b'),
    ex: 'a|b',
    descrText: gettext('Matches either what is before the | or what is after it - in this case `a` or `b`.') + '\n' +
      gettext('You can use alternates locally as part of a capturing/non-capturing group. For example: /I love (?:cats|dogs) but hate snakes/'),
    descrEx: 'a|b',
    results: [{
      t: 'a',
      s: true
    }, {
      t: ' or ',
    }, {
      t: 'b',
      s: true
    }, {
      t: ', pick one!',
    }, ],
  },
  {
    name: gettext('Any whitespace character'),
    ex: '\\s',
    descrText: gettext('Matches any space, tab or newline character.'),
    descrEx: '\\s',
    results: [{
        t: 'any',
      },
      {
        t: ' ',
        s: true
      },
      {
        t: 'whitespace',
      },
      {
        t: ' ',
        s: true
      }, {
        t: 'character',
      },
    ],
  },
  {
    name: gettext('Any non-whitespace character'),
    ex: '\\S',
    descrText: gettext('Matches anything other than a space, tab or newline.'),
    descrEx: '\\S+',
    results: [{
        t: 'any',
        s: true
      },
      {
        t: ' ',
      },
      {
        t: 'non-whitespace',
        s: true
      },
      {
        t: ' ',
      }, {
        t: 'character',
        s: true
      },
    ]
  },
  {
    name: gettext('Any digit'),
    ex: '\\d',
    descrText: gettext('Matches any decimal digit. Equivalent to [0-9].'),
    descrEx: '\\d',
    results: [{
        t: 'one: ',
      },
      {
        t: '1',
        s: true
      },
      {
        t: ', two: ',
      },
      {
        t: '2',
        s: true
      }
    ]
  },
  {
    name: gettext('Any non-digit'),
    ex: '\\D',
    descrText: gettext('Matches anything other than a decimal/digit.'),
    descrEx: '\\D+',
    results: [{
        t: 'one: ',
        s: true
      },
      {
        t: '1',
      },
      {
        t: ', two: ',
        s: true
      },
      {
        t: '2',
      }
    ],
  },
  {
    name: gettext('Any word character (ASCII only)'),
    ex: '\\w',
    descrText: gettext('Matches any letter, digit or underscore. Equivalent to [a-zA-Z0-9_]. It goes not work for unicode (ASCII only).'),
    descrEx: '\\w+',
    results: [{
        t: 'any',
        s: true
      },
      {
        t: ' ',
      },
      {
        t: 'word',
        s: true
      }, {
        t: ' ',
      },
      {
        t: 'character',
        s: true
      },
    ],
  },
  {
    name: gettext('Any non-word character (ASCII only)'),
    ex: '\\W',
    descrText: gettext('Matches anything other than a letter, digit or underscore. Equivalent to [^a-zA-Z0-9_]. It goes not work for unicode (ASCII only)'),
    descrEx: '\\W+',
    results: [{
        t: 'any',
      },
      {
        t: '.',
        s: true
      },
      {
        t: 'a',
      }, {
        t: '@',
        s: true
      },
      {
        t: 'word',
      }, {
        t: '%',
        s: true
      }, {
        t: 'character',
      },
    ],
  },
  {
    name: gettext('Match everything enclosed'),
    ex: '(?:...)',
    descrText: gettext('A non-capturing group allows you to apply quantifiers to part of your regex but does not capture/assign an ID.') + '\n' +
      gettext('For example, repeating 1-3 digits and a period 3 times can be done like this: /(?:\d{1,3}\.){3}\d{1,3}/'),
    descrEx: 'match this (?:match that)',
    results: [{
        t: 'match this match that',
        s: true
      },
      {
        t: '. Other',
      },
    ],
  },
  {
    name: gettext('Capture everything enclosed'),
    ex: '(...)',
    descrText: gettext('Isolates part of the full match to be later referred to by ID within the regex or the matches array. IDs start at 1.') + '\n' +
      gettext('A common misconception is that repeating a capture group would create separate IDs for each time it matches. If that functionality is needed, one has to rely on the global (/g) flag instead. For example: /each (word)/g'),
    descrEx: 'match and (capture )+',
    results: [{
        t: 'match and capture capture ',
        s: true
      },
      {
        t: 'other capture',
      },
    ],
  },
  {
    name: gettext('Zero or one of a'),
    ex: 'a?',
    descrText: gettext('Matches an `a` character or nothing.'),
    descrEx: 'ba?',
    results: [{
        t: 'xx',
      },
      {
        t: 'b',
        s: true
      },
      {
        t: 'yy',
      }, {
        t: 'ba',
        s: true
      },
      {
        t: 'aazz',
      }, {
        t: 'b',
        s: true
      },
    ],
  },
  {
    name: gettext('Zero or more of a'),
    ex: 'a*',
    descrText: gettext('Matches zero or more consecutive `a` characters.'),
    descrEx: 'ba*',
    results: [{
        t: 'xx',
      },
      {
        t: 'b',
        s: true
      },
      {
        t: 'yy',
      }, {
        t: 'baaa',
        s: true
      },
      {
        t: 'zz',
      }, {
        t: 'ba',
        s: true
      },
    ],
  },
  {
    name: gettext('One or more of a'),
    ex: 'a+',
    descrText: gettext('Matches one or more consecutive `a` characters.'),
    descrEx: 'a+',
    results: [{
        t: 'a',
        s: true
      },
      {
        t: ' ',
      }, {
        t: 'aa',
        s: true
      },
      {
        t: ' ',
      }, {
        t: 'aaa',
        s: true
      }, {
        t: ' ',
      }, {
        t: 'aaaa',
        s: true
      }, {
        t: ' b',
      }, {
        t: 'a',
        s: true
      }, {
        t: 'b b',
      }, {
        t: 'aaa',
        s: true
      }, {
        t: 'b',
      },
    ],

  },
  {
    name: gettext('Exactly 3 of a'),
    ex: 'a{3}',
    descrText: gettext('Matches exactly 3 consecutive `a` characters.'),
    descrEx: 'a{3}',
    results: [{
        t: 'a aa ',
      },
      {
        t: 'aaa',
        s: true
      },
      {
        t: ' ',
      }, {
        t: 'aaa',
        s: true
      }, {
        t: 'a',
      },
    ],
  },
  {
    name: gettext('3 or more of a'),
    ex: 'a{3,}',
    descrText: gettext('Matches at least 3 consecutive `a` characters.'),
    descrEx: 'a{3,}',
    results: [{
        t: 'a aa ',
      },
      {
        t: 'aaa',
        s: true
      },
      {
        t: ' ',
      },
      {
        t: 'aaaa',
        s: true
      }, {
        t: ' ',
      },
      {
        t: 'aaaaa',
        s: true
      },
    ],
  },
  {
    name: gettext('Between 3 and 6 of a'),
    ex: 'a{3,6}',
    descrText: gettext('Matches between 3 and 6 (inclusive) consecutive `a` characters.'),
    descrEx: 'a{3,6}',
    results: [{
        t: 'a aa ',
      },
      {
        t: 'aaa',
        s: true
      },
      {
        t: ' ',
      },
      {
        t: 'aaaa',
        s: true
      }, {
        t: ' ',
      },
      {
        t: 'aaaaaa',
        s: true
      }, {
        t: 'aa',
      },
    ],
  }, {
    name: gettext('Start of string '),
    ex: '^',
    descrText: gettext('Matches the start of a string without consuming any characters. If /m multiline mode is used, this will also match immediately after a newline character.'),
    descrEx: '^\\w+',
    results: [{
        t: 'start',
        s: true
      },
      {
        t: ' of string',
      },
    ],
  }, {
    name: gettext('End of string'),
    ex: '$',
    descrText: gettext('Matches the end of a string without consuming any characters. If multiline mode is used, this will also match immediately before a newline character.'),
    descrEx: '\\w+$',
    results: [{
        t: 'end of ',
      },
      {
        t: 'string',
        s: true
      },
    ],
  }, {
    name: gettext('A word boundary (ASCII only)'),
    ex: '\\b',
    descrText: gettext('Matches, without consuming any characters, immediately between a character matched by \\w and a character not matched by \\w (in either order). It cannot be used to separate non words from words. It goes not work for unicode (ASCII only).'),
    descrEx: 'd\\b',
    results: [{
        t: 'wor',
      },
      {
        t: 'd',
        s: true
      }, {
        t: ' boundaries are od',
      }, {
        t: 'd',
        s: true
      },
    ],
  }, {
    name: gettext('Non-word boundary (ASCII only)'),
    ex: '\\B',
    descrText: gettext('Matches, without consuming any characters, at the position between two characters matched by \\w. It goes not work for unicode (ASCII only).'),
    descrEx: 'r\\B',
    results: [{
        t: 'r',
        s: true
      }, {
        t: 'egex is ',
      }, {
        t: 'r',
        s: true
      },
      {
        t: 'eally cool r',
      },
    ],
  },
];

export function RegExpConstructorModalController(
  $scope,
  $modalInstance,
  FilterResource,
  $modal,
  $window,
  regExp,
  comment,
  showComment,
  colorNum,
  $http,
  $cookies
) {
  $scope.refs = REFS;
  $scope.setClass = i => {
    const m = $scope.refs.length / 2;
    if (i > m) return 'ref-descr_bottom';
    else return 'ref-descr_top';
  };
  $scope.regExp = regExp;
  $scope.comment = comment;
  $scope.showComment = showComment;
  $scope.text = '';
  $scope.results = [];
  $scope.FilterResource = FilterResource;
  $scope.$http = $http;

  const lineBreaksArray = (text, colorNum) => {
    const arr = text.split('\n');
    const l = arr.length - 1;
    return arr.map((t, i) => ({
      word: t,
      colorNum: colorNum,
      lineBreak: i < l
    }));
  };

  $scope.commentChange = (comment) => {
    $scope.comment = comment;
  };

  $scope.onRegExpChange = (regExp, text) => {
    if (!regExp) return;
    if (!text) {
      $scope.result = '';
      return;
    }
    $scope.$http.post('/analytics/execute_regexp/', {
        text,
        regExp,
        colorNum: colorNum,
      }, {
        headers: {
          'X-CSRFToken': $cookies.get('csrftoken'),
        }
      })
      .then(({
        data
      }) => {
        if (data.error) {
          $scope.regErr = {
            text: gettext('Неверное регулярное выражение') + `: /${regExp}/g`,
            message: data.error,
          };
          $scope.result = [];
        } else {
          $scope.regErr = null;
          $scope.result = escapeHtml(data.result, false, true).replaceAll('\n', '<br/>');
        }
        if ($scope.$root.$$phase !== '$digest') $scope.$apply();
      });
  };

  $scope.close = () => {
    $modalInstance.close('');
  };
  $scope.ok = ({
    regExp,
    comment
  }) => {
    $modalInstance.close({
      regExp,
      comment
    });
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/regexp-constructor/regexp-constructor-modal.component.js